define('apps/course-intro/views/items/badge',[
    'apps/course-intro/templates/items/badge',
    'components/asset-player/main',
    'components/transition/transition'
], function (template, assetPlayer, Transition) {
    "use strict";

    return Mn.ItemView.extend({

        "tagName": 'li',

        "template": template,

        "modelEvents": {
            "change": "onChangeModel"
        },

        "initialize": function (options) {
            this.model.set({
                // incrementing itemIndex value, to be more human friendly
                "itemIndex": options.itemIndex + 1,

                "levelGuid": options.levelGuid,
                "levelNum": options.levelNum
            });
        },

        "onChangeModel": function () {
            var playerChannel = assetPlayer.channel;

            this.render();

            playerChannel.command(playerChannel.Event.RENDER, {
                "target": this.$el
            });
        },

        "onShow": function () {
            Transition.create({
                "direction": Transition.Direction.LEFT,
                "context": this,
                "el": this.$el,
                "type": Transition.Type.FADE_IN,
                "duration": 0.8,
                "delay": 0.08 * this.model.get('itemIndex')
            }).start();
        }
    });
});

